import Head from "next/head";

import { defaultServerProps }                                 from "_common/ssrWrapper";
import CategoryPage                                           from "_components/pages/blogs/categoryPage.js";
import { getPostsByCategoryId, getCategoryNames, getAllTags } from "_services/api/blogs";

const component = props => {
	return (
		<>
			<Head>
				<title>
					{props?.categoryName}
				</title>
			</Head>

			<CategoryPage
				categories = { props?.categoryNames }
				postArray = { props?.postArray }
				selectedCategory = { props?.categoryName }
				tags = { props?.tags }
			/>
		</>
	);
};

export default component;

const getServerSideProps = async context => defaultServerProps ( context, async defaultProps => {

	const { categorySlug } = context.query || {};

	const results = await Promise.allSettled (
		[
			getCategoryNames (),
			getAllTags ()
		]
	);

	let categoryNames = [], data = [], tagsData = [];

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					categoryNames = result.value;
					break;

				case 1:
					tagsData = result.value;
					break;

			}
		}
	} );

	const selectedCategoryObj = categoryNames.find ( cat => cat.slug === categorySlug );

	data = await getPostsByCategoryId ( selectedCategoryObj.id );

	const postList = data.map ( post => {
		return {
			id            : post?.id,
			date          : post?.date,
			content       : post?.content?.rendered,
			featuredImage : post?.jetpack_featured_media_url || "",
			tags          : post?.tags,
			slug          : post?.slug,
			title         : post?.title?.rendered,
			categoryName  : selectedCategoryObj.name
		};
	} );

	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=300, stale-while-revalidate=600"
  ); */

	return {
		props: {
			...defaultProps,
			noLayout      : true,
			noAuth        : true,
			postArray     : postList || [],
			tags          : tagsData || [],
			categoryNames : categoryNames || [],
			categoryName  : selectedCategoryObj.name
		}
	};
} );

export { getServerSideProps };
